import { ItiLink as Link } from 'components';
import DataTable, { DataTableColumn } from 'components/tables/data-table';
import useTimeZone from 'hooks/use-timezone';
import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPaginated } from 'services';
import { downloadCsv } from 'services/download-csv';
import { Customer } from 'types';
import { FilterState, LogicalOperator } from 'utils';

export const ReportsTab: FC = () => {
  const navigate = useNavigate();
  const { timeZoneOffset } = useTimeZone();

  const formatHours = (value: number[]) =>
    (value ?? []).map(v => `${((v + timeZoneOffset) % 24 + 24) % 24}:00`).join(', ');

  const columns: DataTableColumn[] = [
    {
      field: 'name',
      label: 'Name',
      width: 80,
      renderCell: (value, row) => <Link to={`/settings/report-groups/${row.id}`}>{value}</Link>
    },
    {
      field: 'customers',
      label: 'Customers',
      width: 80,
      getValueLabel: (value: Customer[]) => ((value ?? []).map(c => c.name).join(", "))
    },
    {
      field: 'activityReportHours',
      label: 'Activity Hours',
      width: 80,
      sortable: false,
      filterable: false,
      getValueLabel: formatHours
    },
    {
      field: 'statusReportHours',
      label: 'Status Hours',
      width: 80,
      sortable: false,
      filterable: false,
      getValueLabel: formatHours
    },
    {
      field: 'inventoryReportHours',
      label: 'Inventory Hours',
      width: 80,
      sortable: false,
      filterable: false,
      getValueLabel: formatHours
    },
    {
      field: 'sendAutomatedReport',
      label: 'Send Emails',
      type: 'boolean',
      width: 100
    }
  ];

  const initialFilters: FilterState = useMemo(
    () => ({ logicalOperator: LogicalOperator.AND, filters: [] }),
    []
  );

  return (
    <div id="customer-table">
      <div className="flex-fill d-flex justify-content-end g-3">
        <button
            id="create-report-group"
            className="btn-primary"
            onClick={() => navigate('/settings/report-groups/new')}
            data-cy="new-report-group-button"
        >
        NEW REPORT GROUP
        </button>
      </div>
      <DataTable
        fetchData={fetchPaginated('customer-report-groups/page')}
        fetchCsv={downloadCsv('customer-report-groups')}
        initialFilters={initialFilters}
        initialPage={{ sortField: 'id', sortDirection: 'asc', pageSize: 25 }}
        initialColumns={columns.map(c => ({ field: c.field, width: c.width }))}
        columns={columns}
      />
    </div>
  );
};
